import React, { useEffect, useState, useMemo, useCallback } from "react";
import { fetchProducts } from "../action/FutbolistaActions";
import "../css/catalogos/css/formaciones/Cancha.css";
import "../css/catalogos/css/formaciones/3.css";
import "../css/catalogos/css/formaciones/6.css";
import "../css/catalogos/css/formaciones/9.css";
import "../css/catalogos/css/formaciones/11.css";
import "../css/catalogos/css/formaciones/Suplentes.css";
import { useDispatch, useSelector } from "react-redux";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import {Animated} from "react-animated-css";
import { SkeletonFormacion, SkeletonButtons } from "../componentes/Skeleton";
import SolidButton from "../componentes/buttons/SolidButton";
// import Zoom from "react-reveal/Zoom";

const Formacion1 = React.memo(({ ciudad, targetUri = "" }) => {
  // Memoizar configuración del servidor
  const config_server = useMemo(() => {
    return JSON.parse(localStorage.getItem("configServer"));
  }, []);

  const dispatch = useDispatch();
  const calificador = useSelector((state) => state.products);
  const userSignin = useSelector((state) => state.userSignin);
  const { userInfo } = userSignin;

  const [load, setLoad] = useState(true);
  const [ciudadData, setCiudadData] = useState('ASUNCION');
  const [isChangingCity, setIsChangingCity] = useState(false);

  // Optimizar la comparación de ciudad
  useEffect(() => {
    if (ciudadData !== ciudad) {
      setCiudadData(ciudad);
      setIsChangingCity(true);
      setLoad(true);
    }
  }, [ciudad, ciudadData]);

  useEffect(() => {
    if (load) {
      const loadData = async () => {
        const startTime = performance.now();
        
        try {
          await dispatch(fetchProducts(ciudad));
          const endTime = performance.now();
          const loadTime = endTime - startTime;
          
          // Mostrar skeleton mínimo 300ms para evitar flashing
          const minShowTime = 300;
          const remainingTime = Math.max(0, minShowTime - loadTime);
          
          setTimeout(() => {
            setLoad(false);
            setIsChangingCity(false);
            if (typeof process !== 'undefined' && process.env.NODE_ENV === 'development') {
              console.log(`⚡ API loaded in ${loadTime.toFixed(2)}ms for ciudad: ${ciudad}`);
            }
          }, remainingTime);
          
        } catch (error) {
          console.error("Error loading products:", error);
          // En caso de error, ocultar inmediatamente
          setLoad(false);
          setIsChangingCity(false);
        }
      };
      
      loadData();
    }
  }, [dispatch, load, ciudad]);

  // Debug: Monitorear estado de los datos
  useEffect(() => {
    if (typeof process !== 'undefined' && process.env.NODE_ENV === 'development') {
      console.log('Formacion1 - Estado actual:', {
        hasItems: !!calificador?.items,
        isArray: Array.isArray(calificador?.items),
        length: calificador?.items?.length,
        load,
        isChangingCity,
        ciudad
      });
    }
  }, [calificador?.items, load, isChangingCity, ciudad]);

  // Función memoizada para manejar habilitación
  const handleHabilitar = useCallback((event) => true, []);

  // Renderizado memoizado de formaciones
  const renderFormaciones = useMemo(() => {
    // Mostrar skeleton mientras carga
    if (load) {
      return (
        <>
          <SkeletonFormacion />
          <div className="comocalificarf">
            <div className="cfff">
              <SkeletonButtons />
            </div>
          </div>
        </>
      );
    }
    
    // Si no hay datos o array vacío, mostrar mensaje
    if (!calificador?.items || !Array.isArray(calificador.items) || calificador.items.length === 0) {
      return (
        <div className="no-registros-container">
          <div className="no-registros-message">
            <h2>📋 No hay registros disponibles</h2>
            <p>No se encontraron productos para mostrar en esta ciudad.</p>
            <p>Intenta seleccionar otra ciudad o vuelve más tarde.</p>
          </div>
          <div className="comocalificarf">
            <div className="cfff">
              <Link to={targetUri + ciudad + "/promociones"}>
                <SolidButton type="red-agregar-c" txt="Promociones"></SolidButton>
              </Link>
              <Link to={targetUri + ciudad + "/convenios"}>
                <SolidButton type="red-agregar-c" txt="Convenios"></SolidButton>
              </Link>
            </div>
          </div>
        </div>
      );
    }

    return (
      <>
        <div>
          <div id="cancha">
            {calificador.items.map((formacion) => {
              let opacarImg = "";
              let opacarTitle = "";
              let opacarCursor = "";
              let habilitar = handleHabilitar;
              let zindex = "";

              return (
                <div
                  key={formacion.id_producto}
                  className={`jugador titular ${formacion.id_producto} ${opacarImg}`}
                  style={{ zIndex: `${zindex}` }}
                  id={formacion.id_producto}
                >
                  <Animated
                    animationIn="bounceIn"
                    animationInDelay={1500}
                    animationOut="bounce"
                    animationInDuration={2000}
                    animationOutDuration={2000}
                    isVisible={true}
                  >
                    <div className="producto-opciones">
                      {/* Opción 1: Ir al detalle o link directo según configuración */}
                      {formacion.habilitar_link_directo === "1" && formacion.link_pagina && formacion.link_pagina.trim() !== "" ? (
                        // Link externo - usar <a>
                        <a
                          className={`link-name ${opacarCursor}`}
                          onClick={habilitar}
                          href={formacion.link_pagina}
                          title="Ir al sitio web del producto"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {formacion.imagen_producto === "" ? (
                            <div>
                              <img
                                className="camiseta"
                                src="/fans/boy1-sm.png"
                                alt="Emprendimientos virtuales sa"
                                style={{ display: "none" }}
                                loading="lazy"
                              />
                              <p
                                className={`nombreju ${opacarTitle}`}
                                style={{ display: "none" }}
                              >
                                {formacion.nombre_producto}
                              </p>
                            </div>
                          ) : (
                            <div>
                              <img
                                alt="Emprendimientos virtuales sa"
                                className="camiseta"
                                src={`${config_server.linkImageProducto}${formacion.imagen_producto}`}
                                loading="lazy"
                              />
                              <p className={`nombreju ${opacarTitle}`}>
                                {formacion.nombre_producto}
                              </p>
                            </div>
                          )}
                        </a>
                      ) : (
                        // Link interno - usar Link de React Router
                        <Link
                          className={`link-name ${opacarCursor}`}
                          onClick={habilitar}
                          to={`/catalogo/producto/${formacion.id_producto}/${formacion.imagen_producto}`}
                          title="Ver detalles del producto"
                        >
                          {formacion.imagen_producto === "" ? (
                            <div>
                              <img
                                className="camiseta"
                                src="/fans/boy1-sm.png"
                                alt="Emprendimientos virtuales sa"
                                style={{ display: "none" }}
                                loading="lazy"
                              />
                              <p
                                className={`nombreju ${opacarTitle}`}
                                style={{ display: "none" }}
                              >
                                {formacion.nombre_producto}
                              </p>
                            </div>
                          ) : (
                            <div>
                              <img
                                alt="Emprendimientos virtuales sa"
                                className="camiseta"
                                src={`${config_server.linkImageProducto}${formacion.imagen_producto}`}
                                loading="lazy"
                              />
                              <p className={`nombreju ${opacarTitle}`}>
                                {formacion.nombre_producto}
                              </p>
                            </div>
                          )}
                        </Link>
                      )}
                    </div>
                  </Animated>
                </div>
              );
            })}
          </div>
        </div>
        
        {/* Botones de Promociones y Convenios */}
        <div className="comocalificarf">
          <div className="cfff">
            <Link to={targetUri + ciudad + "/promociones"}>
              <SolidButton type="red-agregar-c" txt="Promociones"></SolidButton>
            </Link>
            <Link to={targetUri + ciudad + "/convenios"}>
              <SolidButton type="red-agregar-c" txt="Convenios"></SolidButton>
            </Link>
          </div>
        </div>
      </>
    );
      }, [load, calificador?.items, config_server.linkImageProducto, handleHabilitar, ciudad, targetUri, isChangingCity]);

  return (
    <React.Fragment>
      {renderFormaciones}
    </React.Fragment>
  );
});

Formacion1.displayName = 'Formacion1';

export default Formacion1;

// Estilos CSS para el mensaje de no registros
const noRegistrosStyles = `
  .no-registros-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 300px;
    padding: 2rem;
  }
  
  .no-registros-message {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 15px;
    padding: 2rem;
    text-align: center;
    backdrop-filter: blur(10px);
    border: 2px solid rgba(253, 240, 6, 0.3);
    margin-bottom: 2rem;
    max-width: 500px;
  }
  
  .no-registros-message h2 {
    color: #FDF006;
    font-size: 2rem;
    margin-bottom: 1rem;
    font-weight: bold;
  }
  
  .no-registros-message p {
    color: white;
    font-size: 1.1rem;
    margin: 0.5rem 0;
    line-height: 1.5;
  }
  
  @media (max-width: 768px) {
    .no-registros-message {
      padding: 1.5rem;
      margin: 1rem;
    }
    
    .no-registros-message h2 {
      font-size: 1.6rem;
    }
    
    .no-registros-message p {
      font-size: 1rem;
    }
  }
  
  /* Estilos para las opciones del producto */
  .producto-opciones {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
  }
  
  .link-name {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    text-decoration: none;
    transition: all 0.3s ease;
  }
  
  /* Responsive para las opciones */
  @media (max-width: 768px) {
    .link-name {
      font-size: 0.9rem;
    }
  }
`;

// Inyectar estilos para no registros
if (typeof document !== 'undefined') {
  const noRegistrosStyleSheet = document.createElement("style");
  noRegistrosStyleSheet.innerText = noRegistrosStyles;
  document.head.appendChild(noRegistrosStyleSheet);
}
